import React from "react";
import { skillsData } from "../data/mock";
import { Card, CardContent } from "./ui/card";
import {
  Truck,
  TrendingUp,
  BarChart3,
  Settings,
  DollarSign,
  Shield,
  BookOpen,
  Users,
} from "lucide-react";

const iconMap = {
  truck: Truck,
  "trending-up": TrendingUp,
  "bar-chart": BarChart3,
  settings: Settings,
  "dollar-sign": DollarSign,
  shield: Shield,
  book: BookOpen,
  users: Users,
};

const SkillCard = ({ skill, index }) => {
  const Icon = iconMap[skill.icon] || BarChart3;

  return (
    <Card className="group border border-slate-100 bg-white hover:border-teal-100 hover:shadow-md transition-all duration-300">
      <CardContent className="p-5 lg:p-6">
        <div className="flex items-start gap-4">
          <div className="w-10 h-10 rounded-xl bg-slate-50 group-hover:bg-teal-50 flex items-center justify-center text-slate-500 group-hover:text-teal-600 transition-all duration-300 shrink-0">
            <Icon size={20} />
          </div>
          <div className="flex-1 min-w-0">
            <h3 className="text-sm font-semibold text-slate-900 mb-1">
              {skill.category}
            </h3>
            <p className="text-xs text-slate-500 leading-relaxed">
              {skill.description}
            </p>
            {/* Skill bar */}
            <div className="mt-3">
              <div className="h-1.5 bg-slate-100 rounded-full overflow-hidden">
                <div
                  className="h-full rounded-full bg-gradient-to-r from-teal-400 to-teal-500 transition-all duration-1000 ease-out"
                  style={{ width: `${skill.level}%` }}
                />
              </div>
            </div>
          </div>
        </div>
      </CardContent>
    </Card>
  );
};

const Skills = () => {
  return (
    <section id="skills" className="py-14 lg:py-20 bg-white">
      <div className="max-w-6xl mx-auto px-6 lg:px-8">
        <div className="max-w-2xl mb-12 lg:mb-16">
          <p className="text-sm font-medium text-teal-600 tracking-wide uppercase mb-2">
            Expertise
          </p>
          <h2 className="font-serif text-3xl lg:text-4xl font-bold text-slate-900 tracking-tight">
            Core Competencies
          </h2>
          <p className="mt-3 text-slate-500 leading-relaxed">
            Deep domain expertise across supply chain operations, customer success, and data-driven decision making.
          </p>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {skillsData.map((skill, index) => (
            <SkillCard key={skill.category} skill={skill} index={index} />
          ))}
        </div>
      </div>
    </section>
  );
};

export default Skills;
